module.exports = __webpack_public_path__ + "img/what-icon.3b07ea9b.svg";